import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useEffect, useState } from "react";

interface Props {
  name: string;
  add: (param: string) => void;
  error: boolean;
  init: string;
}

export const Text = ({ name, add, error, init }: Props) => {
  const [value, setValue] = useState(init);

  return (
    <>
      <label
        htmlFor="motDePasse"
        className={classNames({"p-error": error && value === "",
        labelSourceExterne: true, })}
      >
        {name}<span className="star">*</span>
      </label>
      <InputText
        id={name}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          add(e.target.value);
        }}
        className={classNames({
          "p-invalid": error && value === "",
          fieldSourceExt: true,
        })}
      />
    </>
  );
};
